import { RRIBaseModel } from './base-model.interface';

export interface RRISort<T extends RRIBaseModel> {
  fieldName: keyof T;
  desc?: boolean;
}
